import React from 'react';
import PropTypes from 'prop-types';

import JBImage from 'components/essentials/JBImage';
import CtaLink from 'components/essentials/Cta/CtaLink';
import Link from 'components/consumer/Link';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';

const FlatColorBanner = ({
  config: { backgroundHex, cta, heading, imageProps, subText },
}) => {
  let imgProps = {};
  const size = imageProps?.size ?? 80;
  if (imageProps?.unitTypes === 'vw') {
    imgProps = { sizes: `${size}vw`.toString() };
  } else {
    imgProps = { width: size };
  }

  const renderImage = () => (
    <JBImage
      src={imageProps.src}
      className="inline w-auto h-auto"
      {...imgProps}
    />
  );
  return (
    <div
      className="bg-gray-light9 text-gray font-sans px-0 py-16 text-center w-full"
      style={{
        backgroundColor: `#${
          backgroundHex && backgroundHex.content
            ? backgroundHex.content
            : 'fafafa'
        }`,
      }}
    >
      <FixedWidthContainer className="FlatColorBanner__content">
        {cta && cta.linkTo ? (
          <Link to={cta.linkTo}>{renderImage()}</Link>
        ) : (
          renderImage()
        )}
        <div className="text-xl font-bold mx-0 my-4">{heading.content}</div>

        {subText && subText.content && (
          <div className="text-sm font-normal mx-0 my-4">{subText.content}</div>
        )}

        {cta && cta.linkTo && (
          <div className="mt-8 mx-0 mb-0">
            <CtaLink to={cta.linkTo} color="brand" styling="solid-button">
              {cta.content}
            </CtaLink>
          </div>
        )}
      </FixedWidthContainer>
    </div>
  );
};

FlatColorBanner.propTypes = {
  config: PropTypes.shape({
    backgroundHex: PropTypes.shape({
      content: PropTypes.string,
    }),
    cta: PropTypes.shape({
      content: PropTypes.string,
      linkTo: PropTypes.string,
    }),
    heading: PropTypes.shape({
      content: PropTypes.string,
    }),
    imageProps: PropTypes.shape({
      size: PropTypes.number,
      src: PropTypes.string,
      unitTypes: PropTypes.string,
    }),
    subText: PropTypes.shape({
      content: PropTypes.string,
    }),
  }),
};

export default FlatColorBanner;
